import type { HotelAndOffer } from '@/interfaces';
import { SupplierLogo } from '../resultList/images/SupplierLogo';
import { HotelResultItemFlightDetails } from './HotelResultItemFlightDetails';
import { HotelResultItemFlightSummary } from './HotelResultItemFlightSummary';
import { HotelResultItemMisc } from './HotelResultItemMisc';
import { HotelResultItemPrice } from './HotelResultPrice';

export const HotelResultItem = ({ offer, hotel }: HotelAndOffer) => {
    const {
        supplier,
        originAirport,
        destinationAirport,
        departureDate,
        departureDateArrival,
        departureStopovers,
        departureTravelDuration,
        returnDate,
        returnDateArrival,
        returnStopovers,
        returnTravelDuration,
        flightDetails,
        board,
        roomDescription,
    } = offer;

    return (
        <div className="grid">
            <div className="grid__unit u-r-size2of3">
                <h3 className="u-licorice u-t4 u-pt16">Flyvning</h3>
                <div className="line--border-right">
                    {flightDetails ? (
                        <>
                            <HotelResultItemFlightDetails flights={flightDetails.outbound} outbound />
                            <HotelResultItemFlightDetails flights={flightDetails.inbound} />
                        </>
                    ) : (
                        <>
                            <HotelResultItemFlightSummary
                                originAirport={originAirport}
                                destinationAirport={destinationAirport}
                                departureTime={departureDate}
                                arrivalTime={departureDateArrival}
                                flightDuration={departureTravelDuration}
                                numberOfStopovers={departureStopovers}
                                outbound
                            />
                            <HotelResultItemFlightSummary
                                originAirport={destinationAirport}
                                destinationAirport={originAirport}
                                departureTime={returnDate}
                                arrivalTime={returnDateArrival}
                                flightDuration={returnTravelDuration}
                                numberOfStopovers={returnStopovers}
                            />
                            {departureStopovers === undefined || returnStopovers === undefined ? (
                                <div className="u-strong u-d1 u-mt4" data-testid="unknownStopoversWarning">
                                    Enkelte flyvninger kan ha mellomlandinger. Gå til tilbyder for å se detaljer om flyving
                                </div>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
            <div className="grid__unit u-r-size1of3 u-m-pl16">
                <hr className="line--horizontal-line u-hide-gt768" />
                <h3 className="u-licorice u-t4 u-pt16">Overnatting</h3>
                <HotelResultItemMisc board={board} roomDescription={roomDescription} />
                <hr className="line--horizontal-line" />
                <h3 className="u-licorice u-t4">Totalpris</h3>
                <SupplierLogo supplier={supplier} className="u-mb4 u-float-right" />
                <HotelResultItemPrice offer={offer} hotel={hotel} />
            </div>
        </div>
    );
};
